import Vue from 'vue'
import Router from 'vue-router'
import Home_page from '@/components/home_page'
import Home_page_next from '@/components/home_page_next'
import List from '@/components/list'

import List_tv from '@/components/list_tv'

import List_online_answer from '@/components/online_answer/list_online_answer'
import Stu_up_question from '@/components/online_answer/stu_up_question'
import Stu_to_answer from '@/components/online_answer/stu_to_answer'

import Send_notice from '@/components/send_notice'

import My from '@/components/my'

import Apply_question from '@/components/apply_question'

import Test from '@/components/test'

import About_us from '@/components/about_us'
import Qrcode from '@/components/qrcode'

import Music from '@/components/music/index'
import Music_detail from '@/components/music/music_detail'

import listMyoptions from '@/components/list_my_options'



Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home_page',
      name: 'home_page',
      component: Home_page
    },
    {
      path: '/',
      name: 'home_page',
      component: Home_page
    },
    {
      path: '/home_page_next',
      name: 'home_page_next',
      component: Home_page_next
    },
    {
      path: '/list',
      name: 'list',
      component: List
    },
    {
      path: '/list_tv',
      name: 'list_tv',
      component: List_tv
    },

    // 在线答疑列表
    {
      path: '/list_online_answer',
      name: 'list_online_answer',
      component: List_online_answer
    },
    {
      path: '/send_notice',
      name: 'send_notice',
      component: Send_notice
    },
    {
      path: '/my',
      name: 'my',
      component: My
    },
    {
      path: '/apply_question',
      name: 'apply_question',
      component: Apply_question,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/stu_up_question',
      name: 'stu_up_question',
      component: Stu_up_question,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/stu_to_answer',
      name: 'stu_to_answer',
      component: Stu_to_answer,
      meta: {
        keepAlive: false
      }
    },

    {
      path: '/test',
      name: 'test',
      component: Test,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/about_us',
      name: 'about_us',
      component: About_us,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/qrcode',
      name: 'qrcode',
      component: Qrcode,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/music',
      name: 'music',
      component: Music,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/music_detail',
      name: 'music_detail',
      component: Music_detail,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/list_my_options',
      name: 'list_my_options',
      component: listMyoptions,
      meta: {
        keepAlive: false
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js